import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createContext } from 'react';

export const ApplicationInsightsContext = createContext<{ appInsights: ApplicationInsights; reactPlugin: ReactPlugin } | null>(null);
